import { AgendaItemDefaults } from "@/components/agendaItems/AgendaItemDefaults";
import { AgendaTemplateForm } from "@/components/agendaTemplate/AgendaTemplateForm";
import { PageHeader } from "@/components/page";
import { useDisableTeam } from "@/components/page/disableTeam";
import { useGetAgenda } from "@/hooks/queryHooks/agendaHooks";
import { useRoleProtected } from "@/hooks/useRoleProtected";
import { Spinner } from "@repo/ui/components/Base/Spinner";
import { useNavigate, useParams } from "react-router-dom";

export const AgendaTemplatePage = () => {
  const { tenantId, agendaTemplateId } = useParams();
  useRoleProtected("admin");

  useDisableTeam();

  const navigate = useNavigate();

  const { data: templateData } = useGetAgenda(
    tenantId ?? "",
    agendaTemplateId ?? ""
  );

  const handleCancel = () => {
    navigate("..");
  };

  const handleSave = () => {
    navigate("..");
  };

  const create = agendaTemplateId === "create";

  if (!tenantId) return null;

  return (
    <div className="flex flex-col flex-grow">
      <PageHeader
        title={create ? "Create Agenda Template" : "Edit Agenda Template"}
      >
        {" "}
      </PageHeader>

      {!create && !templateData && <Spinner />}

      <AgendaItemDefaults defaults={{ template: true }}>
        <AgendaTemplateForm
          key={templateData?.id ?? "create"}
          tenantId={tenantId}
          agendaTemplateFormData={templateData ?? undefined}
          onCancel={handleCancel}
          onSave={handleSave}
        />
      </AgendaItemDefaults>
    </div>
  );
};
